// extracted by mini-css-extract-plugin
module.exports = {"tabs":"RoundTabBar_Default_tabs__3pgRC"};